import React from 'react'

function FieldErrors(props) {
  if(!props.errors || props.errors.length == 0) {
    return null
  }

  return (
    <div className="invalid-feedback d-block">
      {props.errors.map((er) => {
        return <span key={er}>{er}</span>
      })}
    </div>
  )
}

export default FieldErrors